<template>
  <div>
    <DxPopup
      :visible="this.isVisible"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :show-close-button="false"
      :width="1170"
      height="auto"
      title="ΥΠΟΒΟΛΗ ΣΥΓΚΕΝΤΡΩΤΙΚΗΣ ΚΑΤΑΣΤΑΣΗΣ ΠΑΡΑΣΤΑΤΙΚΩΝ"
    >
      <DxPosition at="center" my="bottom" />
      <div class="row">
        <DxDataGrid
          id="gridContainer"
          :data-source="paymentActions"
          key-expr="Id"
          :show-borders="true"
          :word-wrap-enabled="true"
          :show-row-lines="true"
          :row-alternation-enabled="true"
          @row-prepared="onRowPrepared"
          @row-updating="onRowUpdating"
          @editor-preparing="onEditorPreparing"
          @cell-click="downloadFile"
        >
          <DxEditing :allow-updating="true" mode="cell" :use-icons="true" />

          <DxSorting mode="none" />
          <DxColumn
            :allow-editing="false"
            caption="Α/Α"
            data-field="SortOrder"
            width="5%"
            alignment="center"
            sort-order="asc"
          />
          <DxColumn
            :allow-editing="false"
            caption="ΠΕΡΙΓΡΑΦΗ ΕΝΕΡΓΕΙΑΣ"
            data-field="Description"
            width="30%"
          />
          <DxColumn
            :allow-editing="false"
            caption="ΕΝΕΡΓΕΙΑ"
            alignment="center"
          >
            <DxColumn
              :allow-editing="false"
              caption=""
              cell-template="cellTemplate"
              data-field="ActionType"
              width="400"
            />
          </DxColumn>
          <DxColumn
            :allow-editing="false"
            caption="ΗΜ/ΝΙΑ"
            data-type="date"
            data-field="LastProcessDate"
            width="12%"
            alignment="center"
          />
          <DxColumn
            :allow-editing="false"
            caption="ΟΝΟΜΑ ΑΡΧΕΙΟΥ"
            data-field="DocumentFriendlyName"
            width="12%"
            css-class="cell-file-link"
          />
          <template #cellTemplate="{ data }">
            <div>
              <div v-if="mustShow(data) == 1">
                <DxButton
                  caption="down"
                  icon="download"
                  text="Πατήστε για λήψη αρχείου"
                  :element-attr="buttonAttributes"
                  @click="plusClick($event, data)"
                  :disabled="isFinalized || clicked"
                />
              </div>
              <div v-if="mustShow(data) == 2">
                <DxFileUploader
                  select-button-text="Πατήστε για επιλογή αρχείου"
                  :ref="fileUploaderRef"
                  :multiple="false"
                  accept="*"
                  upload-mode="instantly"
                  :allowed-file-extensions="['.pdf']"
                  :max-file-size="5000000"
                  @value-changed="onValueChanged($event, data)"
                  :upload-headers="{ authorization: `Bearer ${token}` }"
                  @uploaded="(e) => onUploaded(e, data)"
                  @upload-error="onUploadError"
                  @content-ready="onContentReady($event)"
                  :disabled="isFinalized"
                />
              </div>
              <div v-if="mustShow(data) == 3">
                <DxButton
                  v-if="!data.data.ServiceFailed"
                  caption="down"
                  icon="columnproperties"
                  text="Πατήστε για αυτόματη λήψη"
                  :disabled="isFinalized || clicked"
                  @click="plusClick($event, data)"
                />
                <DxFileUploader
                  v-else
                  select-button-text="Πατήστε για επιλογή αρχείου"
                  :ref="fileUploaderRef"
                  :multiple="false"
                  accept="*"
                  upload-mode="instantly"
                  :allowed-file-extensions="['.pdf']"
                  :max-file-size="5000000"
                  @value-changed="onValueChanged($event, data)"
                  :upload-headers="{ authorization: `Bearer ${token}` }"
                  @uploaded="(e) => onUploaded(e, data)"
                  @upload-error="onUploadError"
                  @content-ready="onContentReady($event)"
                  :disabled="isFinalized"
                />
              </div>
              <div v-if="mustShow(data) == 9">
                <DxButton
                  caption="upload"
                  icon="exportselected"
                  text="Οριστική υποβολή"
                  :element-attr="buttonAttributes"
                  :disabled="isFinalized || clicked"
                  @click="plusClick($event, data)"
                />
              </div>
            </div>
          </template>
          <template #dowloadButton="{ data }">
            <div v-if="mustShow(data)">
              <DxButton caption="down" icon="download" @click="plusClick()" />
            </div>
          </template>
          <template #webServiceButton="{ data }">
            <div v-if="mustShow(data)">
              <DxButton icon="preferences" @click="plusClick()" />
            </div>
          </template>
        </DxDataGrid>
      </div>
      <div class="row">
        <div class="col-md-2">
          <DxButton
            text="Επιστροφή"
            type="danger"
            styling-mode="contained"
            @click="onClosePopup"
          />
        </div>
        <div class="col-md-3">
          <DxButton
            :visible="isAdmin || isSuperAdmin"
            text="Αναίρεση Υποβολής"
            type="default"
            styling-mode="contained"
            :disabled="!isFinalized"
            @click="onUndoPaymentActionFinalization"
          />
        </div>
        <div class="msg">
          Επιτρεπόμενος τύπος αρχείων: pdf με μέγεθος μικρότερο των 5mb
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxButton } from "devextreme-vue/button";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import { DxPopup, DxPosition } from "devextreme-vue/popup";
import mainService from "../../services/mainService";
import { DxDataGrid, DxColumn, DxEditing } from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import { DxSorting } from "devextreme-vue/data-grid";
import store from "../../store/store";

const fileUploaderRef = "fu";

export default {
  props: ["paymentId", "isVisible", "organizationId"],
  components: {
    DxPopup,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxFileUploader,
    DxButton,
    DxEditing,
    DxPosition,
  },
  data() {
    return {
      fileUploaderInstance: null,
      paymentActions: null,
      fileUploaderRef,
      askedUser: 0,
      clicked: false,
      buttonAttributes: {
        class: "custom-button",
      },
      token: "",
    };
  },
  computed: {
    fileUploader: function () {
      return this.$refs[fileUploaderRef].instance;
    },
    isFinalized() {
      if (this.paymentActions.length > 0) {
        var isFinalized = this.paymentActions.find(
          (x) => x.ActionType == 9
        ).HasBeenProcessed;
        return isFinalized;
      } else return false;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  methods: {
    onRowPrepared(e) {
      if (
        e.rowType == "data" &&
        e.data.DocumentFriendlyName != "" &&
        e.data.DocumentFriendlyName != null
      ) {
        e.cells[4].cellElement[0].classList.add("fileCell");
      }
    },
    onEditorPreparing(e) {
      if (e.parentType == "dataRow") {
        if (e.row.data.ActionId == 3 && e.row.data.HasUpload) {
          e.editorOptions.allowEditing = true;
        } else {
          e.editorOptions.allowEditing = false;
          e.editorOptions.readOnly = true;
        }
      }
    },
    async getPaymentActions() {
      this.paymentActions = [];
      const res = await mainService.get(
        `/PaymentActions/GetPaymentActions?paymentId=${this.paymentId}`
      );

      this.paymentActions = res.data;
    },
    onClosePopup() {
      this.$emit("emit-close-popup", {});
    },
    async onValueChanged(e, data) {
      e.component.option(
        "uploadUrl",
        `${this.$ApiBaseUrl}PaymentActions/UploadPaymentActionFile?organizationId=${this.organizationId}&paymentId=${this.paymentId}&paymentActionId=${data.data.Id}`
      );
    },
    onUploaded(e, cellInfo) {
      notify("Το αρχείο ανέβηκε επιτυχώς!", "success", 2000);
      this.getPaymentActions();
    },
    onUploadError(e) {
      let xhttp = e.request;
      if (xhttp.status === 400) {
        e.message = e.error.responseText;
        notify("Πρόβλημα κατά τη μεταφόρτωση του αρχείου!", "error", 5000);
      }
      if (xhttp.readyState === 4 && xhttp.status === 0) {
        e.message = "Connection refused";
      }
    },
    onContentReady(e) {
      var mitsos = e.element
        .find(".dx-fileuploader-button")
        .dxButton("instance")
        .option("icon", "upload");
    },
    async plusClick(e, data) {

      if (data.data.ActionId == 1) {
        try {
          this.clicked = true;
          var response = await mainService.post(
            `PaymentActions/PaymentFileCreate?organizationId=${this.organizationId}&paymentId=${this.paymentId}&paymentActionId=${data.data.Id}`
          );
          var sampleArr = this.base64ToArrayBuffer(response.data.DocumentFile);
          this.saveByteArray(response.data.DocumentFriendlyName, sampleArr);

          data.data.DocumentFriendlyName = response.data.DocumentFriendlyName;
          data.data.ValidUntil = response.data.ValidUntil;
          data.data.LastProcessDate = response.data.LastProcessDate;
          data.data.DocumentFile = response.data.DocumentFile;

          this.clicked = false;
        } catch (error) {
          notify("Η διαδικασία απέτυχε! Προσπαθήστε ξανά.", "error", 5000);
          this.clicked = false;
        }
      }
      else if (data.data.HasWebService && data.data.ActionId == 3) {

        const res = await mainService.post(
          `PaymentActions/UploadAfeFromWs?organizationId=${this.organizationId}&paymentId=${this.paymentId}&paymentActionId=${data.data.Id}`,
          data.data
        );

        if (res.status == 200 && res.data.Id != null) {
          data.data.HasWebService = res.data.HasWebService;
          data.data.HasUpload = res.data.HasUpload;
          data.data.ActionType = res.data.HasWebService ? 3 : 2;

          if (res.data.ServiceFailed) {
            notify(
              "Η διασύνδεση με την υπηρεσία δεν είναι εφικτή αυτή τη στιγμή!",
              "warning",
              5000
            );
            return;
          }

          data.data.DocumentFriendlyName = res.data.DocumentFriendlyName;
          data.data.ValidUntil = res.data.ValidUntil;
          data.data.LastProcessDate = res.data.LastProcessDate;
          data.data.DocumentFile = res.data.DocumentFile;

          notify(
            "Η διασύνδεση με την υπηρεσία ολοκληρώθηκε επιτυχώς!",
            "success",
            5000
          );
        }
      } else if (data.data.ActionId == 5 && data.data.ActionType == 9) {
        try {
          this.clicked = true;
          const res = await mainService.post(
            `PaymentActions/FinalizePaymentActions`,
            data.data
          );

          if (res.data.Data != null) {
            data.data.LastProcessDate = res.data.Data.LastProcessDate;
            data.data.HasBeenProcessed = res.data.Data.HasBeenProcessed;
            this.clicked = false;
            notify("Η διαδικασία ολοκληρώθηκε επιτυχώς!", "success", 3000);
          } else {
            this.clicked = false;
            notify(res.data.message, "error", 5000);
          }
        } catch (error) {
          this.clicked = false;
          notify("Η διαδικασία απέτυχε! Προσπαθήστε ξανά.", "error", 5000);
        }
      }
    },
    async onUndoPaymentActionFinalization(e, data) {

      try {
        const res = await mainService.get(
          `PaymentActions/UndoPaymentActionFinalization?paymentId=${this.paymentId}`
        );

        if (res.data != null) {
          this.paymentActions.find((x) => x.ActionType == 9).HasBeenProcessed =
            res.data.HasBeenProcessed;
          this.paymentActions.find((x) => x.ActionType == 9).LastProcessDate =
            res.data.LastProcessDate;
          notify("Η διαδικασία ολοκληρώθηκε επιτυχώς!", "success", 3000);
        } else {
          notify(res.data.message, "error", 5000);
        }
      } catch (error) {
        notify("Η διαδικασία απέτυχε! Προσπαθήστε ξανά.", "error", 5000);
      }
    },
    async onRowUpdating(e) {
      var paymentAction = Object.assign(e.oldData, e.newData);
      paymentAction.Id = e.key;

      const res = await mainService.post(
        "PaymentActions/UpdatePaymentAction",
        paymentAction
      );
      if (res.status == 200 && res.data.Id == null) {
        notify(res.data, "error", 5000);
      } else {
        notify("Η αποθήκευση πέτυχε", "success", 3000);
      }
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], { type: "application/pdf" });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },
    mustShow(e) {
      return e.data.ActionType;
    },
    downloadFile(e) {
      if (e.rowType == "data" && e.column.dataField == "DocumentFriendlyName") {
        var sampleArr = this.base64ToArrayBuffer(e.row.data.DocumentFile);
        this.saveByteArray(e.row.data.DocumentFriendlyName, sampleArr);
      }
    },
  },

  async created() {
    await this.getPaymentActions();
    this.token = store.getters.getToken;
  },
};
</script>

<style scoped>
div >>> .dx-fileuploader-file-name {
  font-size: 0.7rem;
}
div >>> .dx-fileuploader-wrapper {
  padding: 7px;
  padding-left: 0 !important;
}
div >>> .dx-template-wrapper {
  text-align: left;
}
div >>> .dx-overlay-wrapper * {
  text-align: left;
}
div >>> .dx-datagrid-content .dx-datagrid-table .dx-row td {
  vertical-align: middle;
}

div >>> .dx-datagrid-content .dx-datagrid-table .dx-row > td,
div >>> .dx-datagrid-content .dx-datagrid-table .dx-row > tr > td {
  vertical-align: middle;
}

div
  >>> .dx-datagrid-content
  .dx-datagrid-table
  [class*="column"]
  + [class*="column"]:last-child {
  float: none;
  display: none;
}
div >>> .dx-button-has-icon .dx-button-content {
  padding: 8px;
  background-color: lightgreen;
}

div >>> .dx-toolbar-label .dx-toolbar-item-content > div {
  font-weight: 700;
  font-size: 1rem;
}
div >>> .fileCell:hover {
  cursor: pointer;
}

div >>> .msg {
  float: right;
  height: 32px;
  line-height: 56px;
  margin-right: 0.5rem;
  font-weight: 700;
}
div >>> .dx-button-mode-contained.dx-button-danger {
  margin-top: 0.5rem;
}
div >>> .dx-button-mode-contained.dx-button-default {
  margin-top: 0.5rem;
}
div >>> .custom-button {
  text-align: left;
  width: 231px;
}
div >>> .dx-header-row .cell-file-link {
  color: gray;
}
div >>> .cell-file-link {
  color: rgb(41, 76, 252);
  font-size: 0.8rem;
  text-decoration: underline;
}
</style>